<div class="progress-loader" [hidden]="!loadingS">
    <span class="fa fa-spinner spinner">
    </span>
</div>

